exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.privacy-statement { padding-top: 40px; padding-bottom: 40px; background: #F3F6FA; }\r\n.privacy-deta h2 {  font-size: 24px; font-family: 'Roboto'; color: #12191B; margin: 0 auto 25px; padding-bottom: 10px; border-bottom: 1px solid #2F79EB;}\r\n.privacy-deta p {   font-size: 16px; font-family: 'Roboto'; color: #4E4E4E; margin-bottom: 20px; font-weight: normal; text-align: justify;}\r\n.privacy-deta p a { color: #2F79EB; }\r\n.privacy-deta ul li { list-style: decimal; font-size: 18px; font-family: 'Hind'; color: #12191B; font-weight: bold;}\r\n.privacy-deta ul li ul li { list-style: lower-latin; font-size: 18px; font-family: 'Roboto'; color: #2F79EB;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/privacy-statement/privacy-statement.component.css
// module id = ../../../../../src/app/privacy-statement/privacy-statement.component.css
// module chunks = main